var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-fade"},on:{"after-leave":_vm.handleAfterLeave}},[(_vm.visible)?[_c('div',{class:_vm.tipClass,style:(_vm.positionStyle)},[_c('i',{class:_vm.iconClass}),_c('span',[_vm._v(_vm._s(_vm.message))])])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }